import { apiInterfaceForJson } from "../common/apiManager";

// ── REST ─────────────────────────────────────────────────────────────────
export const fetchOnlinePlayers = () =>
    apiInterfaceForJson("/game/v1/online", "GET");

export const fetchMyGameStats = () =>
    apiInterfaceForJson("/game/v1/my-stats", "GET");

export const fetchLeaderboard = ({ gameId, period = "alltime", limit = 10 } = {}) => {
    const qs = new URLSearchParams();
    if (gameId) qs.append("gameId", gameId);
    if (period) qs.append("period", period);
    if (limit) qs.append("limit", limit);
    return apiInterfaceForJson(`/game/v1/leaderboard?${qs.toString()}`, "GET");
};

export const submitSinglePlayerScore = ({ gameId, score, durationMs }) =>
    apiInterfaceForJson("/game/v1/score", "POST", { gameId, score, durationMs });

// ── Static catalogue (used by the hub page) ──────────────────────────────
export const GAME_CATALOG = [
    // single player
    { id: "2048",      name: "2048",            mode: "single", icon: "🔢", color: "from-amber-400 to-orange-500",   description: "Combine tiles to reach 2048", time: "5–10 min" },
    { id: "snake",     name: "Snake",           mode: "single", icon: "🐍", color: "from-emerald-400 to-green-600",  description: "Eat, grow, don't crash",        time: "1–3 min" },
    { id: "memory",    name: "Memory Match",    mode: "single", icon: "🧠", color: "from-purple-400 to-fuchsia-600", description: "Flip cards, find pairs",         time: "1–2 min" },
    { id: "reaction",  name: "Reaction Test",   mode: "single", icon: "⚡", color: "from-yellow-400 to-amber-500",   description: "How fast can you click?",        time: "30 sec" },
    // multiplayer
    { id: "tictactoe", name: "Tic-Tac-Toe",     mode: "multi",  icon: "❌", color: "from-blue-400 to-indigo-600",    description: "Classic 3-in-a-row",             time: "30 sec" },
    { id: "rps",       name: "Rock Paper Scissors", mode: "multi", icon: "✊", color: "from-pink-400 to-rose-600",     description: "Best of 5 rounds",              time: "1 min" },
    { id: "quiz",      name: "Quiz Battle",     mode: "multi",  icon: "🧩", color: "from-violet-400 to-purple-600",  description: "5 questions, speed = bonus",     time: "2 min" },
    { id: "typing",    name: "Typing Race",     mode: "multi",  icon: "⌨️", color: "from-sky-400 to-cyan-600",       description: "Type the paragraph first",       time: "1 min" }
];

export const getGameDef = (id) => GAME_CATALOG.find((g) => g.id === id);
